







































import {
    Component,
    Prop,
    Vue,
    Emit,
    Watch,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import moment from 'moment';
import axios from 'axios';

@Component({})
export default class BaseListModal extends Vue {

    @Prop({
        type: Boolean,
        default: false,
    })
    private visible!: boolean;

    @Prop({
        type: Object,
        default() {
            return {};
        },
    })
    private record!: any;

    private form: any = null;

    private moment: any = moment;

    private formLayout = {
        labelCol: {
            span: 7,
        },
        wrapperCol: {
            span: 13,
        },
    };

    private handleOk(e: any) {

        e.preventDefault();
        this.form.validateFields((err: any, fieldsValue: any) => {
            if (err) {
                return;
            }

            const id = this.record.id;

            axios.post('/api/save_fake_list', {id, ...fieldsValue})
                .then((res: any) => {
                    this.updateVisible(false);
                    this.onClose(true);
                });
            });
    }

    private handleCancel() {
        this.updateVisible(false);
        this.onClose(false);
    }

    @Emit('update:visible')
    private updateVisible(visible: boolean): void {}

    @Emit('close')
    private onClose(isOk: boolean) {

    }

    private handleSubmit() {

    }
}
